import React from "react";

import FeedbackHeader from "../../layout/FeedbackHeader";
import FeedbackText from "../Input/FeedbackText";

import { FeedbackFormLayout } from "../../layout/FeedbackFormLayout";

export const Question12FlashCoachExperience = ({
  improvementSuggestion,
  updateFormData,
  onEnterKeyPress,
}) => {
  return (
    <>
      <FeedbackFormLayout
        title={"Experience with FLASH Coach"}
        subtitle={
          "Tell us about your experience using the platform and what you’d improve."
        }
      >
        <FeedbackHeader
          title={
            "Which features do you wish we had? Or if you have any other feedback, do share with us."
          }
        />
        <FeedbackText
          inputID={"improvementSuggestion"}
          inputText={improvementSuggestion}
          updateFormData={updateFormData}
          onEnterKeyPress={onEnterKeyPress}
          placeHolder={"Drop an idea or a suggestion here"}
        />
      </FeedbackFormLayout>
    </>
  );
};
